import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { Checkbox, TextField } from "@material-ui/core";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { AVAILABLE_STATES_FULL } from "./helper/constant";

export function MultipleSelectAutocomplete({value, setValue, mapOptions}) {

  const handleOnChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={AVAILABLE_STATES_FULL}
      disableCloseOnSelect
      getOptionLabel={option => option.title}
      limitTags={1}
      size="small"
      value={value}
      onChange={handleOnChange}
      renderOption={(AVAILABLE_STATES_FULL, { selected }) => (
        <>
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            style={{ marginRight: 8, height: "10px" }}
            checked={selected} />
          {AVAILABLE_STATES_FULL.title}
        </>
      )}
      style={{ width: 250 }}
      renderInput={params => (
        <TextField
          {...params}
          variant="outlined"
          label=""
          placeholder="State"
          style={{
            backgroundColor: "white"
          }} />
      )} />
  );
}
